module.exports = __webpack_public_path__ + "img/493-cf0236.png";